const upload =
{
    tooltip : 'Téléverser'
};

export default upload ;